import { atom } from 'recoil';

const userData = atom({
    key: 'user_data',
    default: {}
});
export {userData}
